export const UnitListSuccess = 'UNIT_LIST_SUCCESS';
export const UnitDetailsSuccess = 'UNIT_DETAILS_SUCCESS';
export const UnitGetFilterSuccess = 'UNIT_GET_FILTER_SUCCESS';

export function setUnitListAction(data) {
  return {
    type: UnitListSuccess,
    payload: data,
  };
}

export function setUnitDetailsAction(data) {
  return {
    type: UnitDetailsSuccess,
    payload: data,
  };
}

export function setUnitFilterAction(data) {
  return {
    type: UnitGetFilterSuccess,
    payload: data,
  };
}
